import React, { } from 'react'
import AboutSection from './AboutSection';
import ContactSection from './ContactSection';
import SubscriptionPackages from '../Containers/SubscriptionPackages';
import { constants } from '../app.constants';
import { CTA, Topic, Circle } from './StyledComponents';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();
  return (
    <div className='flex flex-col bg-white'>
      <div id='home' className='flex flex-col bg-gradient-to-t from-[#41090b] to-[#150303] py-32'>
        <div className='flex flex-row items-center justify-center'>
          <div className='flex flex-col w-1/3 gap-4 text-white'>
            <Topic className='max-w-max'>
              <Circle className='animate-pulse' />
              <span>Legal Insights, Made Accessible.</span>
            </Topic>
            <p className='text-6xl'>Pakistan's Largest Digital Legal Library</p>
            <p className='text-lg'>A one-stop resource for legal researchers.</p>
            <CTA className='max-w-max' onClick={()=> navigate('/auth')}>
              Get Started &nbsp;
              <img src={constants.images.Arrow} alt="cta" width="100" height="100" />
            </CTA>
          </div>
          <img className='w-1/2 h-auto' src={constants.images.Mobile}
            alt="Mobile Svg" />
        </div>
      </div>
      <SubscriptionPackages />
      <AboutSection />
      <ContactSection />
    </div>
  )
}

export default Home;